import { BaseDto, ItemResult } from '../../types';
import { repository, ReduxRepository, AsyncAction } from 'redux-scaffolding-ts';
import { DataStore, QueryResult, Query } from '../../dataStore';
import { container } from '../../../inversify.config';
import HttpService from '../../../services/http-service';
import { AxiosResponse } from 'axios';
import { ToastComponent } from '../../../site/pages/landing-pages/util/toast-component';
import i18n from '../../../i18n';

interface IwsQuestionTranslationState {
  isBusy: boolean;
  result: ItemResult<any>;
}

export interface IwsQuestionFormTranslateLogItemDto extends BaseDto {
  translateProcessId: string;
  totalIwsFormAnswers: number;
  role: string;
  userName: string;
  translatePackageSize: number;
  started: string;
  finished: string;
  translateStatus: TranslateStatusKeys;
}

export enum TranslateStatus {
  Unknown = 0,
  InProcess = 10,
  WithErrors = 20,
  Completed = 30
}
export type TranslateStatusKeys = keyof typeof TranslateStatus;

@repository('@@IWSQUESTIONTRANSLATEFORMS', 'iwsquestiontranslateforms.translate')
export class TranslateIwsQuestionTranslateFormStore extends ReduxRepository<IwsQuestionTranslationState> {
  baseUrl = 'skills/v1';
  initBackgroundTranslateIwsForm = 'translate-iws-question-create-queue';
  retrieveTranslateIwsQuestionLogPath = 'translate-iws-question-get-log';

  public BACKGROUND_TRANSLATE_INITIALIZED = 'BACKGROUND_TRANSLATE_INITIALIZED';

  constructor() {
    super({
      isBusy: false,
      result: undefined
    });

    this.onBackgroundTranslateInitilized.bind(this);
    this.addReducer(this.BACKGROUND_TRANSLATE_INITIALIZED, this.onBackgroundTranslateInitilized, 'AsyncAction');
  }

  public async initBackgroundIwsQuestionFormTranslate() {
    const url = `${this.baseUrl}/${this.initBackgroundTranslateIwsForm}`;

    const httpService = container.get<HttpService>(HttpService);
    return this.dispatchAsync(this.BACKGROUND_TRANSLATE_INITIALIZED, httpService.post(url, null));
  }

  public async getTranslateIwsQuestionLog(query: Query, data?: any): Promise<QueryResult<IwsQuestionFormTranslateLogItemDto>> {
    const httpService = container.get(HttpService);
    const { path, body } = DataStore.getRequestParts(query);

    if (body != null) {
      data = data || {};
      data = { ...data, ...body };
    }

    const result = await this.dispatchAsync(
      this.BACKGROUND_TRANSLATE_INITIALIZED,
      httpService.get<QueryResult<IwsQuestionFormTranslateLogItemDto>>(
        `${this.baseUrl}/${this.retrieveTranslateIwsQuestionLogPath}?${path}`,
        data
      )
    );

    return result.data;
  }

  private onBackgroundTranslateInitilized = (): AsyncAction<AxiosResponse<any>, IwsQuestionTranslationState> => {
    return {
      onStart: () => ({ ...this.state, isBusy: true, result: undefined }),
      onSuccess: result => {
        return { ...this.state, isBusy: false, result: result.data };
      },
      onError: error => {
        ToastComponent({ text: i18n.t('Translate failed'), type: 'error-toast' });
        return {
          ...this.state,
          isBusy: false,
          result: error && error.response && error.response.data && error.response.data.messages ? error.response.data : error
        };
      }
    };
  };
}
